export var AngularServices;
(function (AngularServices) {
    AngularServices["ActiveStreamService"] = "activeStreamService";
    AngularServices["ActiveComponents"] = "activeComponents";
    AngularServices["Auth"] = "Auth";
    AngularServices["BannerUserAcknowledgeApi"] = "BannerUserAcknowledge";
    AngularServices["SsoServiceApi"] = "SsoService";
    AngularServices["CallQualitySurveyService"] = "callQualitySurveyService";
    AngularServices["CommunicationControl"] = "communicationControl";
    AngularServices["CurrentUserHelper"] = "currentUserHelper";
    AngularServices["GlobalUi"] = "globalUi";
    AngularServices["InstitutionHelper"] = "institutionHelper";
    AngularServices["Modal"] = "modalsService";
    AngularServices["PublisherManager"] = "publisherManager";
    AngularServices["RootScope"] = "$rootScope";
    AngularServices["Timeout"] = "$timeout";
    AngularServices["VideoFreezeDetector"] = "videoFreezeDetector";
    AngularServices["VideoProviderFactory"] = "VideoProviderFactory";
    AngularServices["Browser"] = "Browser";
    AngularServices["Pn"] = "pn";
    AngularServices["TrackingFactory"] = "trackingFactory";
    AngularServices["WebrtcConnectionStatsCollector"] = "WebrtcConnectionStatsCollector";
    AngularServices["Mail"] = "mail";
    AngularServices["LogOutFactory"] = "logOutFactory";
    AngularServices["STATE"] = "$state";
    AngularServices["StateParams"] = "$stateParams";
    AngularServices["CannyFactory"] = "cannyFactory";
    AngularServices["RoomHelpersFactory"] = "roomHelpersFactory";
    AngularServices["User"] = "User";
    AngularServices["VideoQualityService"] = "VideoQualityService";
    AngularServices["Q"] = "$q";
    AngularServices["DowngradeCallStateService"] = "downgradeCallStateService";
    AngularServices["PiPService"] = "PiPService";
    AngularServices["SetSinkId"] = "setSinkId";
    AngularServices["Redux"] = "$ngRedux";
    AngularServices["Payment"] = "payment";
    AngularServices["Location"] = "$location";
    AngularServices["V2"] = "v2";
    AngularServices["ClosedCaptionsService"] = "closedCaptionsService";
    AngularServices["GrowthbookFactory"] = "growthbookFactory";
})(AngularServices || (AngularServices = {}));
export const getAngularServiceOrUndefined = (name) => {
    const angular = require('angular');
    const $injector = angular.element(document).injector();
    return $injector?.get(name);
};
export const getAngularService = (name) => {
    const angular = require('angular');
    const $injector = angular.element(document).injector();
    if ($injector?.get === undefined) {
        throw new Error(`Couldn't find angular injector to get "${name}" service`);
    }
    const service = $injector.get(name);
    if (service === undefined) {
        throw new Error(`Couldn't find "${name}" angular service`);
    }
    return service;
};
